export const PASSWORDS_DO_NOT_MATCH_MESSAGE = 'Passwords do not match.';
